import { render } from "./ViewProposedKeyApproveMod.vue?vue&type=template&id=6b209b12"
import script from "./ViewProposedKeyApproveMod.vue?vue&type=script&lang=js"
export * from "./ViewProposedKeyApproveMod.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__